const buildPrices = (monthly, yearly) => ({
  monthly,
  yearly,
  monthly_equivalent_yearly: Math.round(yearly / 12),
});

// Static fallback for the "buy a new workspace" page (WorkspacePurchase.jsx)
// when /api/razorpay/config is unreachable. Values MUST mirror
// backend/pricing.py PLAN_REGISTRY v2 blocks so displayed price ==
// charged price. See PHASE_0_3_BUILD_SPEC.md Task A.
export const WORKSPACE_PRICES = {
  pro: buildPrices(1999, 19999),     // Director (Pro) v2
  studio: buildPrices(4999, 49999),  // Studio v2
};
